import { useState, useEffect as useEffectOriginal } from 'react'

export useEffect = (dependencies, fn) ->
  useEffectOriginal ->
    do ->
      fn()
    return
  , dependencies
